import { toSegments, toSegment } from './serializers'
import { AddOptions } from 'components/ideal-core-ui'

const Company = () => {
  return (
    <>
      <AddOptions
        texts={{
          title: 'Company Market Segment',
          subtitle: 'Market Segment Options',
          description:
            'Company market segment holds information about the type of market that this particular client serves primarily'
        }}
        url="/v1/market-segments"
        toItemSerializer={toSegment}
        toItemsSerializer={toSegments}
        itemsType="companies"
        cy="company_market_segments"
      />
      <AddOptions
        texts={{
          title: 'Company Type',
          subtitle: 'Company Type Options',
          description: 'Company type within the industry based on the type of work company performs'
        }}
        url="/v1/company-type"
        toItemSerializer={toSegment}
        toItemsSerializer={toSegments}
        itemsType="companies"
        cy="company_types"
      />
    </>
  )
}

export default Company
